import { render, staticRenderFns } from "./checkBalance.vue?vue&type=template&id=31207b54&scoped=true&"
import script from "./checkBalance.vue?vue&type=script&lang=js&"
export * from "./checkBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31207b54",
  null
  
)

export default component.exports